const LAMBDA_TRIGGER_PREFIX = /(?:PreSignUp|PostConfirmation) failed with error (?:Error: )?/;

const SIGN_UP_LAMBDA_MESSAGES = new Set([
  "We couldn't read an email address for this account. Ask your administrator for help",
  "This email hasn't been invited to Physna. Ask your administrator to send you an invite",
  'This email already has an account. Go back and sign in with the option you used to sign up',
  "We couldn't finish creating your account. Try again, or ask your administrator for help",
  "We couldn't finish confirming your account. Ask your administrator for help",
]);

export const GENERIC_AUTH_ERROR_MESSAGE =
  'Go back and try again. If it keeps happening, ask your administrator for help.';

export const getLambdaErrorMessage = (cognitoErrorMessage: string): string | undefined => {
  const prefix = LAMBDA_TRIGGER_PREFIX.exec(cognitoErrorMessage);
  if (!prefix) {
    return undefined;
  }
  const wrappedMessage = cognitoErrorMessage.slice(prefix.index + prefix[0].length).trimEnd();
  const lambdaMessage = wrappedMessage.endsWith('.') ? wrappedMessage.slice(0, -1) : wrappedMessage;
  return SIGN_UP_LAMBDA_MESSAGES.has(lambdaMessage) ? `${lambdaMessage}.` : undefined;
};
